import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { Stack, useTheme } from "@mui/material";
import { type NormalizedRating, type RatingType } from "@src/appV2/redesign/Tiers/utils/types";

type RatingTypeWithoutLateCancel = Exclude<RatingType, "shiftCompletionWithoutLateCancel">;
interface TargetRatingListItemProps {
  workerNormalizedRating: NormalizedRating;
  targetNormalizedRating: NormalizedRating;
  ratingType: RatingTypeWithoutLateCancel;
}

const ratingTypeToPrefix: Record<RatingTypeWithoutLateCancel, string> = {
  onTimeArrival: "Arrive to shifts on time",
  shiftCompletionWithoutCancel: "Work shifts instead of cancelling",
};

const ratingTypeToNoEventsMessage: Record<RatingTypeWithoutLateCancel, string> = {
  onTimeArrival: "Arrive to your next shift on time",
  shiftCompletionWithoutCancel: "Work your next shift without cancelling",
};

export function TargetRatingListItem(props: TargetRatingListItemProps) {
  const { workerNormalizedRating, targetNormalizedRating, ratingType } = props;
  const { rating: workerRating, ratingHasEvents: workerHasEvents } = workerNormalizedRating;
  const { rating: targetRating, display: targetDisplayPercentage } = targetNormalizedRating;
  const isTargetRatingMet = workerRating >= targetRating;
  const prefix = ratingTypeToPrefix[ratingType];
  const theme = useTheme();
  return (
    <Text>
      {!workerHasEvents && (
        <Stack direction="row" alignItems="top" gap={2}>
          <CbhIcon type="diamond" size="small" sx={{ color: theme.palette.text.secondary }} />
          <Text variant="body1" sx={{ color: theme.palette.text.secondary }}>
            {ratingTypeToNoEventsMessage[ratingType]}
          </Text>
        </Stack>
      )}
      {workerHasEvents && isTargetRatingMet && (
        <Stack direction="row" alignItems="top" gap={2}>
          <CbhIcon type="diamond" size="small" sx={{ color: theme.palette.text.secondary }} />
          <Text variant="body1" sx={{ color: theme.palette.text.secondary }}>
            {prefix} to maintain {targetDisplayPercentage}
            {targetRating === 100 ? "" : "+"}
          </Text>
        </Stack>
      )}
      {workerHasEvents && !isTargetRatingMet && (
        <Stack direction="row" alignItems="top" gap={2}>
          <CbhIcon type="diamond" size="small" sx={{ color: theme.palette.text.secondary }} />
          <Text variant="body1" sx={{ color: theme.palette.text.secondary }}>
            {prefix} to raise {targetRating - workerRating}%
          </Text>
        </Stack>
      )}
    </Text>
  );
}
